/**
 * Edit Event Page
 *
 * Admin page for editing an existing event.
 */

import { Link, useParams } from 'react-router-dom';
import { EventForm } from '../../../components/events';

export default function EditEventPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div>
      {/* Page header */}
      <div className="mb-8">
        <Link
          to={`/admin/events/${id}`}
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Event
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Edit Event</h1>
        <p className="text-gray-600 mt-1">Update event details</p>
      </div>

      {/* Event form */}
      <EventForm eventId={id} />
    </div>
  );
}
